import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";

const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";

const getCurrentDate = () => {
  const date = new Date();
  return `${date.getDate()}_${date.getMonth() + 1}_${date.getFullYear()}`;
};

const setSheetName = (n1: string, n2: string): string => {
  let sheetName = `${n1}_${n2}`;
  return sheetName.length >= 30 ? sheetName.substring(0, 30) : sheetName;
};

const setFileName = (n1: string, n2: string, t1: any) =>
  `${setSheetName(n1, n2)}_${t1}_${getCurrentDate()}`;

export const exportAsExcelFile = (json: unknown[], excelFileName: any) => {
  const title = "Car Sell Report";
  const myworksheet = XLSX.utils.json_to_sheet(json);
  const myworkbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(myworkbook, myworksheet, "data");
  const excelBuffer = XLSX.write(myworkbook, {
    bookType: "xlsx",
    type: "array",
  });
  saveAsExcelFile(excelBuffer, excelFileName);
};

export const exportTableAsExcelFile = (
  json: any,
  t1: any,
  n1: string,
  n2: string
) => {
  const ws = XLSX.utils.table_to_sheet(json, { display: true });
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, setSheetName(n1, n2));
  XLSX.writeFile(wb, setFileName(n1, n2, t1) + EXCEL_EXTENSION);
};

const saveAsExcelFile = (buffer: BlobPart, fileName: string) => {
  const data = new Blob([buffer], { type: EXCEL_TYPE });
  FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
};
